import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col, Input, FormGroup } from "reactstrap";
import InputCustom from "@pages/components/InputCustom";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import {InputKeySelect} from "@pages/components/InputSelect";
import {validateForm} from "../../../../../constants";

export default function CustomerInfoTab({
                                           initialCustomer,
                                           titles = {},
                                           clearMenus,
                                           updateDeal,
                                        }) {
    const [customer, setCustomer] = useState({});
    const [customerInfoIsNotValid, setCustomerInfoIsNotValid] = useState(false)

    useEffect(() => {
        if (initialCustomer) {
            setCustomer(initialCustomer);
        }
    }, [initialCustomer]);
    useEffect(() => {
        const required = ['address', 'driver_license_number', 'email', 'full_name', 'mobile_number', 'postal_code']
        setCustomerInfoIsNotValid(!validateForm(required, customer));
    }, [customer])
    const getTitleText = (titleKey) => (titleKey && titles[titleKey]) || "";

    const handleNameUpdate = (field, value) => {
        const updated = {
            ...customer,
            [field]: value,
        };

        const titleText = getTitleText(updated.title);
        const firstName = updated.first_name || "";
        const lastName = updated.last_name || "";

        updated.full_name = `${firstName} ${lastName}`.trim();
        updated.attention_to = `${titleText} ${firstName} ${lastName}`.trim();

        setCustomer(updated);
    };

    return (
        <Card>
            <CardHeader><h2>Personal information</h2></CardHeader>
            <CardBody>
                <Row className="phone-container">
                    {/* Column 1 */}
                    <Col>
                        <Col>
                            <InputKeySelect
                                newLabel="Title"
                                options={titles}
                                value={customer?.title || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        title: e.target.value,
                                        attention_to: `${e.target.value ? `${titles[e.target.value]} ` : ""}${customer.first_name || ""}${customer.last_name ? ` ${customer.last_name}` : ""}`,
                                    })
                                }
                                defaultOption
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="First Name"
                                placeholder="First Name"
                                type="text"
                                value={customer?.first_name || ""}
                                onChange={(e) => handleNameUpdate("first_name", e.target.value)}
                            />
                        </Col>
                        <Col>
                            <FormGroup className="d-flex align-items-center">
                                <label className="form-control-label w-50">Last Name</label>
                                <Input
                                    placeholder="Last Name"
                                    type="text"
                                    value={customer?.last_name || ""}
                                    onChange={(e) => handleNameUpdate("last_name", e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="N.I Number"
                                value={customer?.national_insurance_number || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        national_insurance_number: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="D/L Number"
                                required
                                checkValid={false}
                                value={customer?.driver_license_number || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        driver_license_number: e.target.value,
                                    })
                                }
                            />
                        </Col>
                    </Col>

                    {/* Column 2 */}
                    <Col>
                        <Col>
                            <FormGroup className="d-flex align-items-center">
                                <label className="form-control-label w-50">Attention To</label>
                                <Input
                                    placeholder="Attention To"
                                    type="text"
                                    value={customer?.attention_to || ""}
                                    onChange={(e) =>
                                        setCustomer({
                                            ...customer,
                                            attention_to: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Email Address"
                                required
                                checkEmail
                                checkValid={false}
                                value={customer?.email || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        email: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Phone Number"
                                required
                                checkValid={false}
                                value={customer?.mobile_number || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        mobile_number: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Land Line Number"
                                value={customer?.land_line_number || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        land_line_number: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Postal Code"
                                required
                                checkValid={false}
                                value={customer?.postal_code || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        postal_code: e.target.value,
                                    })
                                }
                            />
                        </Col>
                    </Col>

                    {/* Column 3 */}
                    <Col>
                        <Col>
                            <InputCustom
                                placeholder="Full Name"
                                newLabel="Full Name"
                                type="text"
                                required
                                checkValid={false}
                                value={customer?.full_name || ""}
                                disabled
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Address"
                                required
                                checkValid={false}
                                value={customer?.address || ""}
                                onChange={(e) =>
                                    setCustomer({
                                        ...customer,
                                        address: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <FormGroup className="d-flex align-items-center">
                                <label className="form-control-label w-50">Building</label>
                                <Input
                                    placeholder="Building"
                                    type="text"
                                    value={customer?.building || ""}
                                    onChange={(e) =>
                                        setCustomer({
                                            ...customer,
                                            building: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup className="d-flex align-items-center">
                                <label className="form-control-label w-50">Street</label>
                                <Input
                                    placeholder="Street"
                                    type="text"
                                    value={customer?.street || ""}
                                    onChange={(e) =>
                                        setCustomer({
                                            ...customer,
                                            street: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup className="d-flex align-items-center">
                                <label className="form-control-label w-50">City</label>
                                <Input
                                    placeholder="City"
                                    type="text"
                                    value={customer?.city || ""}
                                    onChange={(e) =>
                                        setCustomer({
                                            ...customer,
                                            city: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                    </Col>
                </Row>

                <div className="d-flex flex-row justify-content-end mt-5">
                    <ButtonContainer onClick={()=>{clearMenus()}}>Cancel</ButtonContainer>
                    <ButtonContainer
                        disabled={customerInfoIsNotValid}
                        reverse
                        onClick={() => updateDeal({customerData: customer})}
                    >
                        Update
                    </ButtonContainer>
                </div>
            </CardBody>
        </Card>
    );
}
